module.exports = __webpack_public_path__ + "static/smile-12ab03c286c2926992297fc3477ad4de.png";